var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 1.98047H3.99984C3.64622 1.98047 3.30708 2.12094 3.05703 2.37099C2.80698 2.62104 2.6665 2.96018 2.6665 3.3138V13.9805C2.6665 14.3341 2.80698 14.6732 3.05703 14.9233C3.30708 15.1733 3.64622 15.3138 3.99984 15.3138H11.9998C12.3535 15.3138 12.6926 15.1733 12.9426 14.9233C13.1927 14.6732 13.3332 14.3341 13.3332 13.9805V5.98047M9.33317 1.98047L13.3332 5.98047M9.33317 1.98047L9.33317 5.98047H13.3332M10.6665 9.3138H5.33317M10.6665 11.9805H5.33317M6.6665 6.64714H5.33317",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/FileText.898d4efa12d2e051131f2d89f12a6005.svg";
export { ForwardRef as ReactComponent };